var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-button',{attrs:{"size":"medium","variant":"smooth","color-scheme":"alert","icon":"delete","is-disabled":_vm.disableDeleteButton},on:{"click":_vm.deleteAttachments}},[_vm._v("\n  "+_vm._s(_vm.$t('FILE_STORAGE.DELETE.BUTTON'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }